import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-129" data-mp="2av1rs2qqff0o">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:p-0" data-id="element-130" data-mp="38ap5aq9nnyae">
          <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-gold-400 px-6 py-4 text-base font-extrabold uppercase tracking-wide text-navy-950 shadow-[0_12px_30px_-6px_rgba(0,0,0,0.55)] ring-2 ring-white focus:outline-none focus-visible:ring-4 sm:w-auto" data-id="element-131" data-mp="332hqm3a7s158">
            <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-132" data-mp="2fgb6iinimuyn" />
            Get It Now — $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}